import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { responseError } from '../../helpers/responseHandler'
import { useEditProfileMutation, useGetProfileQuery } from '../../redux/services/ProfileService'
import { convertToFormData, sweetAlert } from '../../utils'
import LoadingButtonWithForm from '../LoadingButtonWithForm'
import GlobalLoading from '../GlobalLoading'
import PhoneInput from 'react-phone-input-2'

const UpdateProfile = () => {
  let {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()

  const [editRequest, { isLoading: editLoading }] = useEditProfileMutation()
  const { data: data2, isLoading, isFetching } = useGetProfileQuery()
  const profileData = data2?.response?.data

  const [isEditMode, setIsEditMode] = useState(false)

  // jab profile data aaye, form reset kardo
  useEffect(() => {
    if (profileData) {
      reset(profileData)
    }
  }, [profileData, reset])

  const onSubmit = async data => {
    const newForm = convertToFormData(data)
    await editRequest(newForm)
      .unwrap()
      .then(res => {
        if (res?.status) {
          sweetAlert(res?.message, 'success')
          setIsEditMode(false) // save ke baad disable
        }
      })
      .catch(err => {
        responseError(err)
      })
  }

  return (
    <>
      {isLoading || isFetching ? (
        <GlobalLoading />
      ) : (
        <div className='row'>
          <div className='col-xl-12'>
            <div className=''>
              <div className='p-5'>
                <div className='mb-4 main-content-label'>Personal Information</div>
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className='form-horizontal'
                  id='profile-status'
                >
                  {/* FIRST NAME */}
                  <div className='form-group '>
                    <div className='row'>
                      <div className='col-md-2'>
                        <label className='form-label'>FIRST NAME</label>
                      </div>
                      <div className='col-md-10'>
                        <Controller
                          name='first_name'
                          control={control}
                          defaultValue={profileData?.first_name || ''}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='text'
                              placeholder='Enter First Name'
                              isInvalid={errors.first_name}
                              disabled={!isEditMode}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  {/* LAST NAME */}
                  <div className='form-group '>
                    <div className='row'>
                      <div className='col-md-2'>
                        <label className='form-label'>LAST NAME</label>
                      </div>
                      <div className='col-md-10'>
                        <Controller
                          name='last_name'
                          control={control}
                          defaultValue={profileData?.last_name || ''}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type='text'
                              placeholder='Enter Last Name'
                              isInvalid={errors.last_name}
                              disabled={!isEditMode}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  {/* EMAIL - always disabled */}
                  <div className='form-group '>
                    <div className='row'>
                      <div className='col-md-2'>
                        <label className='form-label'>EMAIL</label>
                      </div>
                      <div className='col-md-10'>
                        <Form.Control
                          type='email'
                          placeholder='Enter Email'
                          defaultValue={profileData?.email || ''}
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  {/* PHONE */}
                  <div className='form-group '>
                    <div className='row'>
                      <div className='col-md-2'>
                        <label className='form-label'>PHONE NUMBER</label>
                      </div>
                      <div className='col-md-10'>
                        <Controller
                          name='phone'
                          control={control}
                          defaultValue={profileData?.phone || ''}
                          render={({ field }) => (
                            <PhoneInput
                              {...field}
                              country={'us'}
                              inputProps={{
                                name: 'phone',
                                disabled: !isEditMode,
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  {/* PROFILE */}
                  <div className='form-group '>
                    <div className='row'>
                      <div className='col-md-2'>
                        <label className='form-label'>Profile</label>
                      </div>
                      <div className='col-md-10'>
                        <Controller
                          name='profile'
                          control={control}
                          defaultValue={''}
                          render={({ field }) => (
                            <Form.Control
                              onChange={e => field.onChange(e.target.files[0])}
                              type='file'
                              isInvalid={errors.profile}
                              disabled={!isEditMode}
                            />
                          )}
                        />
                        {profileData?.profile && (
                          <img src={profileData?.profile_url} alt='profile' width={80} />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* COMPANY LOGO */}
                  <div className='form-group '>
                    <div className='row'>
                      <div className='col-md-2'>
                        <label className='form-label'>Company Logo</label>
                      </div>
                      <div className='col-md-10'>
                        <Controller
                          name='company_logo'
                          control={control}
                          defaultValue={''}
                          render={({ field }) => (
                            <Form.Control
                              onChange={e => field.onChange(e.target.files[0])}
                              type='file'
                              isInvalid={errors.company_logo}
                              disabled={!isEditMode}
                            />
                          )}
                        />
                        {profileData?.company_logo && (
                          <img src={profileData?.company_logo_url} alt='company_logo' width={80} />
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              {/* Footer Buttons */}
              <div className='card-footer d-flex justify-content-end'>
                {isEditMode ? (
                  <>
                    <button
                      type='button'
                      className='btn ripple btn-light w-sm me-2'
                      onClick={() => {
                        reset(profileData)
                        setIsEditMode(false)
                      }}
                    >
                      Cancel
                    </button>
                    <LoadingButtonWithForm
                      isLoading={editLoading}
                      name='Save'
                      form='profile-status'
                    />
                  </>
                ) : (
                  <button
                    type='button'
                    className='btn ripple btn-primary w-sm'
                    onClick={() => setIsEditMode(true)}
                  >
                    Edit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default UpdateProfile
